export default __webpack_public_path__ + "static/media/paymentTutorial_mobile_bottom_Cn.f98e3659.webp";